function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.375 13.246a8.855 8.855 0 01-5.415 1.83 8.84 8.84 0 01-5.395-1.83L0 15.349v5.201h17.92v-5.2l-3.545-2.104zM8.98 12.194A6.097 6.097 0 108.98 0a6.097 6.097 0 000 12.194z",
  fill: "#fff"
});

function SvgEmptyAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgEmptyAvatar;